import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { authUtils } from '../../utils/authUtils';
import axios from 'axios';
import Divider from '@mui/material/Divider';

export default function PgmVersionComponent(props) {
  const { id, handleVersionClose, handleVersionRegisterOpen, setVersionState, getDataList } = props;

  const [content, setContent] = useState('');

  const onClickDelete = async (e) => {
    axios
      .delete(`/api/version/${id}`)
      .then((response) => {
        alert(response.data.message);
        handleVersionClose();
        getDataList();
      })
      .catch((error) => {
        alert(error.response.data.message);
      });
  };

  const handleVersionRegister = async () => {
    await handleVersionClose();
    await setVersionState(!!id ? 'modify' : 'register');
    await handleVersionRegisterOpen();
  };

  useEffect(async () => {
    if (!!id) {
      const response = await axios.get(`/api/board/version/${id}`);
      await setContent(response.data.content);
    }
  }, []);

  return (
    <>
      <div class="version">
        <Box component="div" dangerouslySetInnerHTML={{ __html: content }} sx={{ minWidth: 1200, height: 800, overflow: 'auto' }} />
      </div>
      <Divider sx={{ mb: 2 }} />
      {authUtils.useIsAdmin() && (
        <Button variant="contained" onClick={handleVersionRegister}>
          {!!id ? '수정' : '등록'}
        </Button>
      )}
      {!!id && authUtils.useIsAdmin() && (
        <Button variant="contained" onClick={onClickDelete}>
          삭제
        </Button>
      )}
    </>
  );
}
